import { CLICK_ACTIONS, IMPRESSION_ACTIONS, SCREEN_NAME } from "../constants";
import { AnalyticsContextValue } from "@swiggy-private/checkout-core";

export const impressionRemoveAllOOSItems = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartId?: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_REMOVE_ALL_OOS_ITEMS,
        context: cartId !== undefined ? JSON.stringify({ cartId }) : undefined,
    });
};

export const impressionRemoveAllOOSItemsMRO = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    parentCartId?: number | string,
    cartId?: number | string,
): void => {
    impressionEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_REMOVE_ALL_OOS_ITEMS,
        context: JSON.stringify({
            // eslint-disable-next-line @typescript-eslint/naming-convention
            parent_cart_id: parentCartId,
            // eslint-disable-next-line @typescript-eslint/naming-convention
            cart_id: cartId,
        }),
    });
};

export const clickRemoveAllOOSItems = (
    cartAmount: number,
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartId?: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.CHECKOUT,
        action: CLICK_ACTIONS.CLICK_REMOVE_ALL_OOS_ITEMS,
        value: cartAmount,
        context: cartId !== undefined ? JSON.stringify({ cartId }) : undefined,
    });
};

// quick checkout footer events
export const impressionOutletUnserviceable = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartIds: Array<number>,
    parentCartId?: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.QUICK_CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_OUTLET_UNSERVICEABLE,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        context: JSON.stringify({ cart_id: cartIds, parent_cart_id: parentCartId }),
    });
};

export const clickOutletUnserviceable = (
    clickEvent: AnalyticsContextValue["clickEvent"],
    cartIds: Array<number>,
    parentCartId?: number,
): void => {
    clickEvent({
        category: SCREEN_NAME.QUICK_CHECKOUT,
        action: CLICK_ACTIONS.CLICK_OUTLET_UNSERVICIBLE,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        context: JSON.stringify({ cart_id: cartIds, parent_cart_id: parentCartId }),
    });
};

export const impressionLoginPrompt = (
    impressionEvent: AnalyticsContextValue["impressionEvent"],
    cartIds: Array<number>,
    parentCartId?: number,
): void => {
    impressionEvent({
        category: SCREEN_NAME.QUICK_CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_LOGIN_PROMPT,
        // eslint-disable-next-line @typescript-eslint/naming-convention
        context: JSON.stringify({ cart_id: cartIds, parent_cart_id: parentCartId }),
    });
};

export const clickLoginPrompt = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.QUICK_CHECKOUT,
        action: CLICK_ACTIONS.CLICK_LOGIN_PROMPT,
    });
};

export const impressionAddItemError = (impressionEvent: AnalyticsContextValue["impressionEvent"]): void => {
    impressionEvent({
        category: SCREEN_NAME.QUICK_CHECKOUT,
        action: IMPRESSION_ACTIONS.IMPRESSION_ITEM_ADD_ERROR,
    });
};

export const clickAddItemError = (clickEvent: AnalyticsContextValue["clickEvent"]): void => {
    clickEvent({
        category: SCREEN_NAME.QUICK_CHECKOUT,
        action: CLICK_ACTIONS.CLICK_ITEM_ADD_ERROR,
    });
};
